import validate from 'validate.js';

import { makeConstraintsForRequired } from '@crm-framework/validation';

export const validateFields = (
  field: Record<string, any>,
  requiredFields: string[]
) => {
  const requiredConstraints: any = makeConstraintsForRequired(
    requiredFields,
    false
  );

  requiredConstraints.amount.numericality = {
    onlyInteger: false,
    greaterThan: 0,
  };

  requiredConstraints.cardNumber.format = {
    pattern: '^[0-9 ]+$',
    message: 'must be a number.',
  };

  return validate(field, requiredConstraints);
};
